import React from 'react';
import {View} from 'react-native';
import {isEmpty} from 'lodash';

import ListItem from '/component/base/ListItem';
import PersonListItem from '/component/base/PersonListItem';
import Text from '/component/base/Text';
import ProfileSection from '/component/partial/profile/ProfileSection';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './ProfileMentorsSection.style';

const POSITION_LABEL = {
  businessCoach: 'Business Coach',
  globalDirector: 'Global Director',
  presidentialDirector: 'Presidential Director',
};

interface Mentor {
  position: keyof typeof POSITION_LABEL;
  coach: {id: string; firstName: string; lastName: string; avatarUrl: string};
}

interface ProfileMentorsSectionProps {
  tt: (key: string, value: string) => string;
  mentors: Mentor[];
}

//HIDDEN: CONNAPP-613
export const ProfileMentorsSection = ({
  tt = withTranslation.ttDefaultProp,
  mentors = [] /*onMentorCoachPress*/,
}: ProfileMentorsSectionProps) => {
  const renderedMentors: any = [];

  (mentors || []).map(({position, coach}: any, index: number) => {
    const itemStyle = [styles.listItem];
    if (index > 0) {
      itemStyle.push(styles.listItemWithBorder);
    }

    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (isEmpty(coach) && !isEmpty(POSITION_LABEL[position])) {
      renderedMentors.push(
        <View key={index} style={itemStyle}>
          <ListItem
            readonly
            prefix={<View style={styles.disabledAvatar} />}
            label={
              <Text
                allowFontScaling
                maxFontSizeMultiplier={2}
                emphasis="disabled"
                variant="button">
                {tt('rank.emptyState', `No ${POSITION_LABEL[position]}`)}
              </Text>
            }
          />
        </View>,
      );
    } else {
      const {id, firstName, lastName, avatarUrl} = coach;

      renderedMentors.push(
        <View key={index} style={itemStyle} accessible={true}>
          <PersonListItem
            index={index}
            totalCount={mentors.length}
            readonly
            isCoach={true}
            allowFontScaling
            maxFontSizeMultiplier={2}
            name={`${firstName} ${lastName}`}
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            role={tt(`rank.${position}`, POSITION_LABEL[position])}
            avatarUrl={avatarUrl}
            avatarEmail={`${id}@${position}.com`}
            hasChevron={false}
            /*onPress={() => onMentorCoachPress({mentorCoachId: id})}*/
          />
        </View>,
      );
    }
  });

  return (
    <ProfileSection
      analyticsTitle="Mentorship Team"
      style={{base: styles.base}}
      title={tt('heading', 'Mentorship Team')}>
      {renderedMentors}
    </ProfileSection>
  );
};

export default ProfileMentorsSection;
